import { useQuery } from 'react-query';
import { apiGetAccessToken, QUERY_KEY_CHECK_LOGIN } from './apiGetAccessToken';

export const useGetAccessToken = (params = {}, options = {}) => {
  return useQuery({
    queryKey: [QUERY_KEY_CHECK_LOGIN, params],
    queryFn: () => apiGetAccessToken(params),
    refetchOnWindowFocus: true,
    ...options,
  });
};
